module.exports = __webpack_public_path__ + "img/input-count-plus.d8a7e4a2.svg";